import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../pages/AuthContext';
import { useI18n } from '../i18n/I18nContext';
import { setAnalyticsReady, startAnalyticsCollector, trackAnalyticsPage } from '../utils/analytics';

const AnalyticsTracker = () => {
  const { pathname, key } = useLocation();
  const { loading } = useAuth();
  const { locale } = useI18n();

  useEffect(() => startAnalyticsCollector(), []);
  useEffect(() => {
    setAnalyticsReady(!loading);
    if (!loading) trackAnalyticsPage(pathname, locale, key);
  }, [pathname, key, locale, loading]);

  return null;
};

export default AnalyticsTracker;
